import React from 'react';
import { Paragraph as P } from '../../../Paragraph';
import * as styles from './index.module.css';

export type DialogFooterProps = React.PropsWithChildren<{
  text?: React.ReactNode;
}>;

export function Footer({ text, children }: DialogFooterProps) {
  return (
    <div className={styles.modalFooter}>
      {children && <div className={styles.buttons}>{children}</div>}
      {text && <div>{text}</div>}
    </div>
  );
}
